/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DuplicatePlanningRequestPost } from '../../models/duplicate-planning-request-post';
import { DuplicatePlanningResponse } from '../../models/duplicate-planning-response';

export interface PlanningsControllerDuplicatePlanning$Params {

/**
 * The id of the planning to duplicate.
 */
  id: string;
      body: DuplicatePlanningRequestPost
}

export function planningsControllerDuplicatePlanning(http: HttpClient, rootUrl: string, params: PlanningsControllerDuplicatePlanning$Params, context?: HttpContext): Observable<StrictHttpResponse<DuplicatePlanningResponse>> {
  const rb = new RequestBuilder(rootUrl, planningsControllerDuplicatePlanning.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DuplicatePlanningResponse>;
    })
  );
}

planningsControllerDuplicatePlanning.PATH = '/planning-projects/v1/projects/variants/plannings/{id}/duplicate';
